import {CloningStructure} from './cloningStructure';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('Clone')
export class Clone {

    @JsonProperty('questionMap',[CloningStructure])
    questionMap:CloningStructure[] = [];// Map<number,number>;

    // Unused
    @JsonProperty('respondentNoQuestion',Number)
    respondentNoQuestion = 0;

    @JsonProperty('questionnaireIdToBeClonedTo',Number,true)
    questionnaireIdToBeClonedTo = 0;

    @JsonProperty('questionnaireName',String,true)
    questionnaireName = '';

    @JsonProperty('projectIdRef',Number,true)
    projectIdRef = 0;

    //




 constructor() {

    // this.questionMap = []; // new Map<number,number>();
    /*const tmp: {[key:number]:number} =  json.questionMap;
    for(const [key,value] of Object.entries(tmp)) {

        this.questionMap.set(Number(key),Number(value));
    }*/
    /*this.questionnaireIdToBeClonedTo = json.questionnaireIdToBeClonedTo;
    this.questionnaireName = json.questionnaireName;
    this.projectIdRef = json.projectIdRef;*/
     // this.respondentNoQuestion = json.respondentNoQuestion;
 }

/* toJSON() {

   console.log('Calling toJson method');
   return ({
      questionnaireIdToBeClonedTo:this.questionnaireIdToBeClonedTo,
      questionnaireName:this.questionnaireName,
      projectIdRef:this.projectIdRef,
      respondentNoQuestion:this.respondentNoQuestion,
      // questionMap:this.MapToString()
   });
 }*/


 /*private  MapToString() {

   const tmp: {[key:number]:number} = {};

   for(const key of this.questionMap.keys()) {
     tmp[key] = this.questionMap.get(key);
   }
   return tmp;
 }*/
}
